import { createReducer } from 'redux-act';

import Country from '../../models/interfaces/Country';
import { countriesFetched } from '../actions/place/fetchCountries';

export interface CountryReducerState {
  readonly countries: Country[];
}

const defaultState: CountryReducerState = {
  countries: [],
};

const countryReducer = createReducer<CountryReducerState>({}, defaultState);

countryReducer.on(countriesFetched, (state, { countries }) => ({
  ...state,
  countries,
}));

export default countryReducer;
